import * as jsxRuntime from "/codebuild/output/src3045536685/src/accounts-frontend-reactjs/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment